import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=2a627056&scoped=true"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"
import style0 from "./cascader.vue?vue&type=style&index=0&id=2a627056&prod&lang=less"
import style1 from "./cascader.vue?vue&type=style&index=1&id=2a627056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a627056",
  null
  
)

export default component.exports